export const mapDrawStyles = [
    {
        id: "gl-draw-polygon-fill-inactive",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["!=", "active", "true"]],
        paint: { "fill-color": "#000000", "fill-opacity": 0.05 },
    },
    {
        id: "gl-draw-polygon-fill-active",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "true"]],
        paint: { "fill-color": "#000000", "fill-opacity": 0.1 },
    },
    {
        id: "gl-draw-polygon-stroke-inactive",
        type: "line",
        filter: ["all", ["==", "active", "false"], ["==", "$type", "Polygon"]],
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#000000", "line-width": 4 },
    },
    {
        id: "gl-draw-polygon-stroke-active",
        type: "line",
        filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#000000", "line-width": 4 },
    },
    {
        id: "gl-draw-line-active",
        type: "line",
        filter: ["all", ["==", "active", "true"], ["==", "$type", "LineString"]],
        layout: { "line-cap": "round", "line-join": "round" },
        paint: { "line-color": "#000000", "line-width": 4 },
    },
    {
        id: "gl-draw-point-vertex-default",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "meta", "vertex"]],
        paint: {
            "circle-radius": 5,
            "circle-color": "#ffffff",
            "circle-stroke-color": "#000000",
            "circle-stroke-width": 2,
        },
    },
    {
        id: "gl-draw-point-midpoint",
        type: "circle",
        filter: ["all", ["==", "meta", "midpoint"], ["==", "$type", "Point"]],
        paint: {
            "circle-radius": 5,
            "circle-color": "#a6a5a5",
            "circle-stroke-color": "#000000",
            "circle-stroke-width": 1,
        },
    },
    {
        id: "gl-draw-point-active",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "meta", "feature"]],
        paint: { "circle-radius": 6, "circle-color": "#000000" },
    },
];
